import ContestHeader from 'contest/ui/contest-header';
import ContestActionsData from 'contest/data/actions';
import Slideshow from 'contest/ui/slideshow';
import SlideshowTrigger from 'contest/ui/slideshow-trigger';
import ContestExtensionModal from 'contest/ui/contest-extension-modal';
import CreativeConsultantModal from 'contest/ui/contest-creative-consultant-modal';
import PaymentsModalHandler from 'payments/data/payments-modal-handler';

import initIndicator from 'contest/apps/online-status/init-indicator';

const initOnlineStatus = () => {
    const lastSeenIndicator = document.querySelector('[data-last-seen-time-url]');
    if (lastSeenIndicator && window.activeUser) {
        initIndicator(lastSeenIndicator);
    }
};

$(function() {
    initOnlineStatus();

    // Contest Header
    ContestHeader.attachTo('[data-contest-header]');
    ContestActionsData.attachTo(document);

    Slideshow.attachTo('[data-slideshow]', {
        resetEvent: 'modal:afterHide:contest-welcome',
        showStepEvent: 'contestStatusSlideshowShowStep',
    });

    SlideshowTrigger.attachTo('[data-slideshow-trigger]', {
        broadcastEvent: 'contestStatusSlideshowShowStep',
    });

    ContestExtensionModal.attachTo('[data-contest-extension-modal]');
    CreativeConsultantModal.attachTo('[data-creative-consultant-modal]');

    PaymentsModalHandler.attachTo('body', {
        showEvent: 'uiPaymentModalRequested',
    });
});



// WEBPACK FOOTER //
// ./src/web/js/contest/layout.jsx